import styled from 'styled-components'

export const List = styled.ul`
    font-weight: 500;
    font-size: 12px;
    line-height: 18px;
    color: #2E2D37;
    padding-right: 12px;
    li {
        display: inline-block;
        margin-left: 12px;
        &::before {
            margin-left: 6px;
            content: '\\2022';
            left: -5px;
            position: relative;
        }
    }
`
